// The permission page (D-070, B-061): a section or page the signed-in member's role doesn't
// open, reached by a typed or bookmarked address or a link. Calm, not an error: nothing is
// broken, the role simply doesn't include it.

import { brand } from '@enp/brand';
import { Button, EmptyState, PageHeader } from '@enp/ui';
import { Link } from '@tanstack/react-router';
import { ArrowRight, Lock } from 'lucide-react';
import { useDocumentTitle } from './page.js';

export interface NoAccessProps {
  /** The section's name, as the menu shows it ("Purchasing"). */
  section?: string | undefined;
  /** h1 when the panel IS the page (default); h2 inside a page with its own title. */
  titleAs?: 'h1' | 'h2';
}

export function NoAccess({ section, titleAs = 'h1' }: NoAccessProps) {
  useDocumentTitle(titleAs === 'h1' ? section : undefined);
  const where = section ?? 'This page';
  const state = (
    <EmptyState
      compact
      icon={Lock}
      titleAs={titleAs === 'h1' ? 'h2' : 'h3'}
      title="Your role doesn’t open this page"
      description={`${where} isn’t part of your role. If you need it, ask the owner to change your role in the ${brand.appNames.admin}.`}
      action={
        <Button variant="secondary" asChild>
          <Link to="/">
            Go to the dashboard
            <ArrowRight aria-hidden />
          </Link>
        </Button>
      }
    />
  );
  if (titleAs === 'h2') return <div data-testid="no-access">{state}</div>;
  return (
    <div data-testid="no-access">
      <PageHeader title={section ?? 'No access'} />
      {state}
    </div>
  );
}
